import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, IconButton } from '@material-ui/core';
import { T } from 'Actions/translate';
import BasicButton from 'Components/common/BasicButton';
import { ArrowBackIos } from '@material-ui/icons';
import { getPersonalInfo } from 'Actions/userCenter';
import { updateShipTo } from 'Actions/order';//update SCME-1072
import { openNotification } from 'Actions/notification';
import util from 'Utils/commonUtil';
import { loadLanguage } from 'Utils/jwtUtil';

class PersonalInfor extends Component {

	componentWillMount() {
        this.props.getPersonalInfo();
	}

	componentDidMount(){
		if (document.body.style.overflow === 'hidden') {
			document.body.style.overflow = '';
		}
	}

	updateShipToNum = (email,shipToNum) => {
		const params = {};
		params.email = email;
		params.shipToNum =  shipToNum;
		this.props.updateShipTo(params).then(() => {
            this.props.openNotification(T('notification_successfully_set'), 'success');
			this.props.getPersonalInfo();
        });
	}

	render() {
		const { personalInfor } = this.props;
		let lang = loadLanguage();

		return (
			<div className='userinfor'>
				<Grid className='ship-to-head container-max-width is-fixed' container spacing={0} justify={'space-evenly'}>
					<Grid className='back-icon' item xs={3}>
						<IconButton color='inherit' onClick={() => this.props.history.push('userCenter')}>
							<ArrowBackIos/>
						</IconButton>
					</Grid>

					<Grid className={ util.getClassName({
						'page-title': true && lang !== 'EN',
						'en-page-title': true && lang === 'EN'
					}) } item xs={9}>
						<span>{T('user_center_account_information')}</span>
					</Grid>
				</Grid>

				<div className="content ">
					<section className="content-box">
						<Grid container spacing={0} justify={'center'}>
							<Grid item xs={6}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('lastName')}</span>
									{personalInfor && personalInfor.baseInfo ? personalInfor.baseInfo.lastName : null}
								</div>
							</Grid>
							<Grid item xs={6}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('firstName')}</span>
									{personalInfor && personalInfor.baseInfo ? personalInfor.baseInfo.firstName : null}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('email')}</span>
									{personalInfor && personalInfor.baseInfo ? personalInfor.baseInfo.email : null}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('mobile')}</span>
									{personalInfor && personalInfor.baseInfo ? personalInfor.baseInfo.mobile : null}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('institution')}</span>
									{personalInfor && personalInfor.baseInfo ? personalInfor.baseInfo.institution : null}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('labOrDept')}</span>
									{personalInfor && personalInfor.baseInfo ? personalInfor.baseInfo.labOrDept : null}
								</div>
							</Grid>
						</Grid>
					</section>
				</div>

				{personalInfor && personalInfor.shipTos && personalInfor.shipTos.length > 0 ?
					personalInfor.shipTos.map((item, i) => {
							return (item.isAssociatedSc ? <div key={i} className="userinfor-content">
					<section className="content-box">
						<Grid container spacing={0} justify={'center'}>
							<Grid item xs={12}>
								<div className='user-infor'>
					<span className='user-infor-title'>{T('shipTo')}</span>
									{item.stNumber}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('shippingAddress')}</span>
									{util.formatAddress(item.stCity, item.stAddress, item.stBuilding)}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('billAddress')}</span>
									{util.formatAddress(item.btCity, item.btAddress, item.btBuilding)}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<span className='user-infor-title'>{T('invoiceTitle')}</span>
									{item.btInstitution}
								</div>
							</Grid>
							<Grid item xs={12}>
								<div className='user-infor'>
									<BasicButton className='update-buttom' disabled={item.isAssociatedSc ? false : true} type={item.defaultShipTo ? 'primary':'info'} onClickOfSingleTap={item.defaultShipTo ? null : () => this.updateShipToNum(personalInfor.baseInfo.email,item.stNumber)}>
										<span>{item.defaultShipTo ? T('user_center_default') : T('user_center_set_default')}</span>
									</BasicButton>
								</div>
							</Grid>
						</Grid>
					</section>
					{item.isPrepay ? <div className={ util.getClassName({
								'tag': true,
								'shipped': true && lang !== 'EN',
								'en-shipped': true && lang === 'EN'
						}) }></div> : null }
				</div> : null)
				}) : null}
			</div>
		);
	}
}

const mapStateToProps = state => {
	const { userCenter } = state;
	return {
		personalInfor: userCenter.personalInfor.data,
	};
};

const mapDispatchToProps = {
	getPersonalInfo,
	updateShipTo,
	openNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfor);
